
import React from 'react';

interface HeroImageProps {
  imageUrl: string;
  alt: string;
  portraitMode?: boolean;
  imageObjectPosition?: string;
  isHomepage?: boolean;
  loading?: 'eager' | 'lazy';
}

const HeroImage: React.FC<HeroImageProps> = ({ 
  imageUrl, 
  alt, 
  portraitMode = false,
  imageObjectPosition = 'object-center',
  isHomepage = false,
  loading = 'lazy'
}) => {
  const imgWidth = portraitMode ? 600 : 800;
  const imgHeight = portraitMode ? 800 : 450;

  return (
    <div className={`relative rounded-lg overflow-hidden shadow-xl ${portraitMode ? 'aspect-[3/4]' : 'aspect-[16/9]'}`}>
      {/* Skeleton placeholder with fixed dimensions to prevent CLS */}
      <div className="absolute inset-0 bg-joerg-100" aria-hidden="true"></div>
      
      <img
        src={imageUrl}
        alt={alt}
        width={imgWidth}
        height={imgHeight}
        loading={loading}
        fetchPriority={isHomepage ? "high" : undefined}
        className={`w-full h-full object-cover ${imageObjectPosition} relative z-10 force-visible`}
        decoding={isHomepage ? "sync" : "async"}
        onError={(e) => {
          console.error(`Failed to load image: ${imageUrl}`);
          const target = e.target as HTMLImageElement;
          target.src = '/lovable-uploads/92a40837-332a-4ab3-9edd-e8ae91dec053.png';
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent z-10"></div>
    </div>
  );
};

export default HeroImage;
